import { Controller } from 'react-hook-form'

import { FormsLayout } from 'components/Layout/Forms'
import { InputField } from 'components/InputField'
import Button from 'components/Button'
import { IdentificationsDataTypes } from 'types/identifications'

import Dropdown from 'components/Dropdown'
import { useMemberIdentificationsMerge } from './useMemberIdentificationsMerge'
import { useMemberIdentificationsMergeForm } from './useMemberIdentificationsMergeForm'

import { MERGE_OPTIONS } from 'constants/filters'
import { useState } from 'react'
import Modal from 'components/Modal'

interface MergeFormData {
  addNewCardFlag: string
  identDonor: string
}

const Index = ({
  modalClose,
  selectedRowData,
}: {
  modalClose: () => void
  selectedRowData: IdentificationsDataTypes
}): JSX.Element => {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const {
    memberIdentificationsMergeModStatus,
    memberIdentificationsMergeParams,
    memberHandleIdentificationsMerge,
  } = useMemberIdentificationsMerge({
    modalClose,
    selectedRowData,
  })

  const { control, handleSubmit, setValue, watch , errors} =
    useMemberIdentificationsMergeForm({
      defaultValues: memberIdentificationsMergeParams,
    })

  const handleConfirmSubmit = (data: MergeFormData) => {
    setShowConfirmation(true)
  }

  return (
    <>
      <FormsLayout.Wrapper
        onSubmit={handleSubmit(handleConfirmSubmit)}
      >
        <FormsLayout.Item>
          <Controller
            name="addNewCardFlag"
            control={control}
            render={({ field }) => (
              <Dropdown
                title="Merge Options"
                defaultValue={MERGE_OPTIONS[0]}
                options={MERGE_OPTIONS}
                className="w-full menu-outer-top tracking-wider"
                borderColor="#C4C4C4"
                onSelect={(value) => {
                  setValue('addNewCardFlag', value.value)
                }}
                overflowStyle
              />
            )}
          />
        </FormsLayout.Item>

        <FormsLayout.Item>
          <Controller
            name="identDonor"
            control={control}
            render={({ field }) => (
              <InputField
                onChange={(e) => {
                  setValue('identDonor', e.target.value)
                }}
                type="number"
                name="identDonor"
                label="Card Number"
                helper={
                  watch('addNewCardFlag') === '1'
                    ? '* Enter card number to be merged to this account. This new card number should not have available balance.'
                    : '* Enter card number to be merged to this account'
                }
                containerClassName="flex flex-col flex-grow"
                rounded
                error={errors.identDonor?.message}
              />
            )}
          />
        </FormsLayout.Item>

        <FormsLayout.ActionWrapper>
          <Button
            key="submit"
            type="submit"
            className="rounded bg-primary tracking-wider font-bold"
          >
            Merge identifier
          </Button>
        </FormsLayout.ActionWrapper>
      </FormsLayout.Wrapper>

      <Modal
        open={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        title="Confirm Merge"
        noFooter
      >
        <div className="p-6">
          <p className="mb-6">
            You are about to merge card number {watch('identDonor')} to this account, are you sure you want to proceed?
          </p>
          <div className="flex justify-end gap-4">
            <Button
              onClick={() => {
                memberHandleIdentificationsMerge(watch())
                setShowConfirmation(false)
              }}
              className="rounded bg-primary tracking-wider font-bold"
            >
              Yes
            </Button>
            <Button
              onClick={() => setShowConfirmation(false)}
              className="rounded bg-white border border-primary tracking-wider font-bold"
              style={{ color: 'black' }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Index
